import React from "react";
import { useSelector } from "react-redux";
import Page from "../../../components/general/page";
import TsPayOnboardingLandingPage from "../../../components/tspay/onboarding/onboardingLandingPage";

const TsPayOnboardingLandingView = ({  
  pageRef
}) => {
  const myType = useSelector(state => state.main.myType);
  return (
    <Page pageRef={pageRef} activePage={"/"} noHeaderContent noClassName>
      <div className={"contentStructure"}>
        {myType === "COMPANY" ? (
          <TsPayOnboardingLandingPage />
        ) : null}
      </div>
    </Page>
  );
};

export default TsPayOnboardingLandingView;
